import { CachedStore } from "@fry-it/risr-core";
import { Injectable } from "@angular/core";
import { UserFieldApiResponse, UserField } from "./user-field";

@Injectable({
    providedIn: 'root'
})
export class UserFieldStore extends CachedStore<UserFieldApiResponse, UserField> {
    prefix = 'user-fields';

    public async getAll(): Promise<UserField[]> {
        const userFields = await this.fetchAll();
        return userFields.map(this.fromApiResponse);
    }

    protected fetchOne(key: string): Promise<UserFieldApiResponse> {
        return this.api.get<UserFieldApiResponse>(`/user-fields/${key}`);
    }

    protected fetchAll(): Promise<UserFieldApiResponse[]> {
        return this.api.get<UserFieldApiResponse[]>(`/user-fields/`);
    }

    protected fromApiResponse(response: UserFieldApiResponse): UserField {
        return UserField.fromApiResponse(response);
    }
}